// extracted by mini-css-extract-plugin
export default {"loader":"DetailLoading_loader__7+PMP","l10":"DetailLoading_l10__I4-Sh"};